import styled from 'styled-components';

const Cancel = styled.button`
  border-radius: 3px;
  flex: 1;
  border: 1px solid ${(props: any) => props.theme.carvana.blue.primary};
  background-color: ${(props: any) => props.theme.carvana.white.primary};
  align-items: center;
  justify-content: center;
  color: ${(props: any) => props.theme.carvana.blue.primary};
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-transform: uppercase;
  cursor: pointer;
  :hover {
    border: 1px solid ${(props: any) => props.theme.carvana.blue.hover};
    color: ${(props: any) => props.theme.carvana.blue.hover};
  }
`;

export default Cancel;
